<div class="rotation-offset-toolbar">
  <div class="rotation-offset-buttons" role="group" aria-label="Rotation offset presets">
    @for (btn of buttons; track btn.op) {
      <button type="button"
              [class]="btnClass"
              [class.btn-outline-danger]="btn.op === 'reset' && !isIdentity()"
              [title]="btn.title"
              (click)="onClick(btn.op)">
        {{ btn.label }}
      </button>
    }
  </div>
</div>
